<script>
import XEUtils from 'xe-utils';

export default {
  data() {
    return {
      data: [],
      businessList: [],
      menuList: [],
      currentData: {},
      defaultExpandedkeys: [],
      tableData: [],
      page: {
        total: 0,
        size: 20,
        current: 1
      },
      search: {},
      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const end = XEUtils.toStringDate(XEUtils.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'))
              const start = XEUtils.toStringDate(XEUtils.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '昨日',
            onClick(picker) {
              const newDate = XEUtils.getWhatDay(new Date(), -1)
              const end = XEUtils.toStringDate(XEUtils.toDateString(newDate, 'yyyy-MM-dd 23:59:59'))
              const start = XEUtils.toStringDate(XEUtils.toDateString(newDate, 'yyyy-MM-dd 00:00:00'))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const newDate = XEUtils.getWhatDay(new Date(), 1)
              const end = XEUtils.toStringDate(XEUtils.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'))
              const start = XEUtils.getWhatWeek(XEUtils.toStringDate(XEUtils.toDateString(newDate, 'yyyy-MM-dd 00:00:00')), -1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一月',
            onClick(picker) {
              const newDate = XEUtils.getWhatDay(new Date(), 1)
              const end = XEUtils.toStringDate(XEUtils.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'))
              const start = XEUtils.getWhatMonth(XEUtils.toStringDate(XEUtils.toDateString(newDate, 'yyyy-MM-dd 00:00:00')), -1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '当前月',
            onClick(picker) {
              const end = XEUtils.toStringDate(XEUtils.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'))
              const start = XEUtils.toStringDate(XEUtils.toDateString(new Date(), 'yyyy-MM-01 00:00:00'))
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      loading: false
    }
  },
  mounted() {
    this.search = { identity: '', dateTime: [] }
    this.treeInit('mounted')
  },
  methods: {
    arrayUnique2(arr) {
      const seenCodes = new Set();
      return arr.filter(item => {
        const { actionCode } = item;
        if (actionCode === '') {
          return true;
        }
        if (seenCodes.has(actionCode)) {
          return false;
        } else {
          seenCodes.add(actionCode);
          return true;
        }
      });
    },
    nodeClick(event, node) {
      if (node.level === 3) {
        this.currentData = {
          id: event.id,
          label: event.label,
          name: event.name,
          title1: node.parent.parent.data.name,
          id1: node.parent.parent.id,
          title2: node.parent.data.name,
          id2: node.parent.id,
          title3: event.name,
          id3: event.id
        }
      } else if (node.level === 2) {
        this.currentData = {
          id: event.id,
          label: event.label,
          name: event.name,
          title1: node.parent.data.name,
          id1: node.parent.id,
          title2: event.name,
          id2: event.id,
          title3: '',
          id3: ''
        }
      } else {
        this.currentData = {
          id: event.id,
          label: event.label,
          name: event.name,
          title1: event.name,
          id1: event.id,
          title2: '',
          id2: '',
          title3: '',
          id3: ''
        }
      }
      this.page.current = 1
      this.init()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.init()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.init()
    },
    treeInit(type) {
      this.loading = true
      let startTime = ''
      let endTime = ''
      if (this.search.dateTime && this.search.dateTime.length === 2) {
        startTime = this.search.dateTime[0]
        endTime = this.search.dateTime[1]
      }
      const params = {
        params: {
          tenantName: this.search.currTenantName || undefined,
          userPhone: this.search.userPhone || undefined,
          identity: this.search.identity || undefined,
          begin: startTime || undefined,
          end: endTime || undefined,
        }
      }
      this.$axios.get('/account/menu/queryUserMenuEventCount', params).then((res) => {
        this.businessList = res.data.data.businessList
        this.menuList = this.arrayUnique2(res.data.data.sysMenuTenantListCOList)
        const menuParent = []
        this.menuList.forEach(item => {
          if (item.parentId === -1) {
            let name = item.name
            if (item.urlApp) {
              name = item.name + '-' + item.urlApp
            }
            menuParent.push({ id: item.id, label: name, name: item.name, businessCode: item.businessCode, children: [] })
          }
        })
        this.menuList.forEach(item => {
          if (item.parentId !== -1) {
            menuParent.forEach(_item => {
              if (_item.id === item.parentId) {
                let name = item.name
                if (item.urlApp) {
                  name = item.name + '-' + item.urlApp
                }
                _item.children.push({ id: item.id, label: name, name: item.name, businessCode: item.businessCode })
              }
            })
          }
        })
        const businessParent = []
        this.businessList.forEach(item => {
          let name = item.name
          if (item.urlApp) {
            name = item.name + '-' + item.urlApp
          }
          businessParent.push({ id: item.code, label: name, name: item.name, children: [] })
        })
        menuParent.forEach(item => {
          if (item.businessCode) {
            businessParent.forEach(_item => {
              if (_item.id === item.businessCode) {
                _item.children.push(item)
              }
            })
          }
        })
        this.data = businessParent
        this.page.current = 1
        if (type === 'mounted') {
          if (this.data[0].children && this.data[0].children.length > 0) {
            const item = this.data[0].children[0]
            if (item.children && item.children.length > 0) {
              const _item = item.children[0]
              this.currentData = {
                id: _item.id,
                label: _item.label,
                name: _item.name,
                title1: this.data[0].name,
                id1: this.data[0].id,
                title2: item.name,
                id2: item.id,
                title3: _item.name,
                id3: _item.id
              }
            } else {
              this.currentData = {
                id: item.id,
                label: item.label,
                name: item.name,
                title1: this.data[0].name,
                id1: this.data[0].id,
                title2: item.name,
                id2: item.id,
                title3: '',
                id3: ''
              }
            }
          } else {
            this.currentData = {
              id: this.data[0].id,
              label: this.data[0].label,
              name: this.data[0].name,
              title1: this.data[0].name,
              id1: this.data[0].id,
              title2: '',
              id2: '',
              title3: '',
              id3: ''
            }
          }
          if (this.currentData.id2) {
            this.defaultExpandedkeys = [this.currentData.id2]
          } else {
            this.defaultExpandedKeys = [this.currentData.id1]
          }
        }
        this.$nextTick(() => {
          this.$refs.pointTreeRef.setCurrentKey(this.currentData.id)
          this.init()
        })
      }).catch(() => {
        this.loading = false
      })
    },
    init() {
      const menu1 = this.currentData.title1.split('(')[0]
      let menu2 = undefined
      if (this.currentData.title2) {
        menu2 = this.currentData.title2.split('(')[0]
      }
      let pageName = undefined
      if (this.currentData.title3) {
        pageName = this.currentData.title3.split('(')[0]
      }
      let startTime = ''
      let endTime = ''
      if (this.search.dateTime && this.search.dateTime.length === 2) {
        startTime = this.search.dateTime[0]
        endTime = this.search.dateTime[1]
      }
      const params = {
        params: {
          tenantName: this.search.currTenantName || undefined,
          userPhone: this.search.userPhone || undefined,
          identity: this.search.identity || undefined,
          begin: startTime || undefined,
          end: endTime || undefined,
          pageNum: this.page.current,
          pageSize: this.page.size,
          menu1,
          menu2,
          pageName
        }
      }
      this.$axios.get('/account/menu/queryUserMenuEventCountList', params).then(res => {
        this.tableData = res.data.data.list
        this.tableData.forEach((item) => {
          item.createTime = XEUtils.toDateString(item.createTime)
        })
        this.page.total = res.data.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    changeRow(row, type) {
      this.$set(this.search, type, row[type])
      this.treeInit('search')
    }
  }
}
</script>
<template>
  <div class="point">
    <div class="point-header">
      <div style="color: #333; font-size: 16px; font-weight: bold; margin-right: 10px;">埋点详情</div>
      <el-radio-group @change="treeInit('search')" size="mini" v-model="search.identity" style="margin-right: 10px;"
        :disabled="loading">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="pc">电脑</el-radio-button>
        <el-radio-button label="mini_program">小程序</el-radio-button>
      </el-radio-group>
      <el-input v-model="search.userPhone" placeholder="请输入手机号" size="mini" @change="treeInit('search')" clearable
        style="width: 200px; margin-right: 10px;" :disabled="loading"></el-input>
      <el-input v-model="search.currTenantName" placeholder="请输入企业" size="mini" @change="treeInit('search')"
        :disabled="loading" clearable style="width: 200px; margin-right: 10px;"></el-input>
      <el-date-picker v-model="search.dateTime" type="datetimerange" size="mini" value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至" style="width: 350px;" format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间"
        end-placeholder="结束时间" @change="treeInit('search')" placeholder="选择日期时间" :disabled="loading"
        :picker-options="pickerOptions"></el-date-picker>
    </div>
    <div class="point-tree">
      <el-tree :data="data" node-key="id" highlight-current :expand-on-click-node="false" :indent="10"
        ref="pointTreeRef" @node-click="nodeClick" :default-expanded-keys="defaultExpandedkeys"></el-tree>
    </div>
    <div class="point-body">
      {{ currentData.label }}
      <div style="height: calc(100% - 30px)">
        <el-table :data="tableData" height="90%" border size="mini" style="margin-top: 20px;" v-loading="loading">
          <el-table-column prop="userName" label="用户" width="100" align="center" show-overflow-tooltip />
          <el-table-column prop="userPhone" label="手机号" width="100" align="center" show-overflow-tooltip>
            <template #default="{ row }">
              <div style="color: #409eff; cursor: pointer;" @click="changeRow(row, 'userPhone')">{{ row.userPhone }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="identity" label="用户端" width="80" align="center" show-overflow-tooltip>
            <template #default="{ row }">
              <el-tag :type="row.identity === 'pc' ? 'success' : ''" size="mini">
                {{ row.identity === 'pc' ? '电脑' : '小程序' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="currTenantName" label="企业" min-width="300" align="center" show-overflow-tooltip>
            <template #default="{ row }">
              <div style="color: #409eff; cursor: pointer;" @click="changeRow(row, 'currTenantName')">{{
                row.currTenantName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="platformName" label="场站" min-width="150" align="center" show-overflow-tooltip />
          <el-table-column prop="createTime" label="时间" min-width="150" align="center" show-overflow-tooltip />
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" size="mini" align="center"
          :current-page="page.current" :page-sizes="[20, 50, 80, 100]" :page-size="page.size" style="margin-top: 20px;"
          layout="total, sizes, prev, pager, next, jumper" :total="page.total" background>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.point {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  min-width: 1200px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  color: #333;

  .point-header {
    width: 100%;
    height: 60px;
    margin-bottom: 20px;
    background: #fff;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding: 10px 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .point-tree {
    width: 350px;
    height: calc(100% - 80px);
    background: #fff;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .point-body {
    width: calc(100% - 370px);
    margin-left: 20px;
    height: calc(100% - 80px);
    background: #fff;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding: 20px;
    box-sizing: border-box;
  }

}
</style>
